module.exports = __webpack_public_path__ + "img/sberpay_1.b334c811.svg";